module.exports = __webpack_public_path__ + "img/logo.4b4e8c3d.png";